// ─── Shared error helpers for all configuration service modules ──────────────

const FIREBASE_TO_DOMAIN_CODE = {
  'permission-denied': 'CONFIG_PERMISSION_DENIED',
  'not-found': 'CONFIG_NOT_FOUND',
  unauthenticated: 'CONFIG_UNAUTHENTICATED',
};

const DOMAIN_ERROR_MESSAGES = {
  CONFIG_PERMISSION_DENIED: 'You do not have permission to access this configuration.',
  CONFIG_NOT_FOUND: 'Configuration not found.',
  CONFIG_UNAUTHENTICATED: 'Please sign in again and retry.',
  CONFIG_LOAD_FAILED: 'Failed to load configuration.',
  CONFIG_SAVE_FAILED: 'Failed to save configuration.',
};

const getFirebaseCode = (error) => {
  const code = error?.code;
  if (!code || typeof code !== 'string') return null;
  if (code.includes('/')) return code.split('/')[1];
  if (code.includes(':')) return code.split(':')[1];
  return code;
};

export const toConfigError = (error, fallbackCode = 'CONFIG_LOAD_FAILED') => {
  const firebaseCode = getFirebaseCode(error);
  const code = FIREBASE_TO_DOMAIN_CODE[firebaseCode] || fallbackCode;
  const message = DOMAIN_ERROR_MESSAGES[code] || error?.message || 'Unknown error';
  return {code, message, rawCode: error?.code || null, cause: error || null};
};

export const ok = (data = null) => ({ok: true, data, error: null});
export const fail = (error) => ({ok: false, data: null, error});

export const logError = (context, errorInfo) => {
  console.error(`[configApi:${context}] ${errorInfo.code}: ${errorInfo.message}`, errorInfo.cause || errorInfo);
};

